import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  // Every unmatched path is handled by the catch-all in routes/$.tsx, which
  // renders the legacy tree (whose own "*" route renders NotFound). TanStack's
  // own not-found handling must not pre-empt that while the seam is in place.
  defaultNotFoundComponent: () => null,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
